export default __webpack_public_path__ + "static/media/callIcon-filled.44e4f897.svg";